import cx from "classnames";
import React, { useEffect,Fragment, useRef, useState } from "react";
import Switch from "react-switch";

const CratioToggle = ({ value,onChange,label }) => {
   
    useEffect(() => {
      (async () => {
      })();     
    });
    
    return (
        <div className="cratio-toggle"> 
        <Switch checked={value} onChange={onChange} onColor="#a8e8ad"
        onHandleColor="#23ae73" handleDiameter={25} uncheckedIcon={false} checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={15} width={43} className="me-2 mb-2" id="material-switch"/>
        <span>{label}</span>
         </div>
        );       
   
  };
  
  export default CratioToggle;